import { useState } from 'react';
import fleetApi from '../../services/api.service';

export default function useCreatePhoneNumber() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const createPhoneNumber = async (title, phoneNumber) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/clients/phone-numbers', {
        title,
        phone_number: phoneNumber,
      });

      if (response.status === 201) {
        setIsSuccess(true);
        return response.data.phone_number;
      } else {
        setIsSuccess(false);
        throw new Error(response.data.message || 'Erreur lors de la création');
      }
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue lors de la création du numéro de téléphone.'
      );
      setIsSuccess(false);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    createPhoneNumber,
    resetStates,
  };
}
